import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { Link } from '@stackflow/link';
import { pressActionEffect } from '@styles/mixin';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import useRecentOrders from './hooks/useRecentOrders';
import RecentOrderItem from './RecentOrderItem';

function RecentOrders() {
    const recentOrders = useRecentOrders();
    const isSingle = recentOrders?.length === 1;
    const { t } = useTranslation('main', { keyPrefix: 'recentOrders' });
    if (recentOrders && recentOrders.length > 0) {
        return (
            <div>
                <Row fullWidth justify='space-between'
                    css={css`margin: 0 0 var(--spacing-4); padding: 0 var(--spacing-4);`} >
                    <Text color={colors.gray8}
                        size='title'
                        fontWeight='bold' >
                        {t('title')}
                    </Text>
                    <Link activityName='OrderLogsActivity'
                        activityParams={{ duration: 'WEEK' }}>
                        <Row css={pressActionEffect}>
                            <Text color={colors.gray6} size='body-long'>
                                {t('showAll')}
                            </Text>
                            <ArrowLineRight size={16} />
                        </Row>
                    </Link>
                </Row>
                <Contents>
                    {recentOrders?.map((order) => (
                        <RecentOrderItem order={order}
                            isSingle={isSingle}
                            key={order.orderId} />
                    ))}
                </Contents>
            </div>
        );
    }
    return (<Fragment/>);
}

const Contents = styled.div`
    padding: 0 var(--spacing-4) var(--spacing-12);
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    width: 100vw;
    display: flex;
    column-gap: var(--spacing-2);
    scroll-padding: 0 var(--spacing-4);
    &::-webkit-scrollbar {
        display: none;
    }
`;

export default RecentOrders;
